<div class="modal-header">
    <h2 class="modal-title" translate>lblSearchPackage</h2>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
        <span aria-hidden="true">×</span>
    </button>
</div>
<div class="modal-body p-0 min-h500">
    <div class="popup-vcenter">
        <div class="card pad15">
            <div class="form-row">
                <div class="col-auto">
                    <label for="template-make" translate>lblMake</label>
                    <div class='lbl-info'>
                        <ng-select placeholder="{{ 'lblSelectMake' | translate }}" [(ngModel)]="brandCode">
                            <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                                {{type.brandCode}}</ng-option>
                        </ng-select>
                    </div>
                </div>
                <div class="col-auto">
                    <label for="service" translate>lblPackageNumber
                        <strong class="mlt6 required"> * </strong>
                    </label>
                    <div class='lbl-info'>
                        <input class="form-control mb-2" [(ngModel)]="packageNumber"
                            placeholder="{{ 'lblPackageNumber' | translate }}" maxlength="40" (keyup.enter)="onSearchPackage()">
                    </div>
                </div>
                <div class="col-4">
                    <label for="service" translate>lblPackageName
                        <strong class="mlt6 required"> * </strong>
                    </label>
                    <div class='lbl-info'>
                        <input class="form-control mb-2" [(ngModel)]="packageName"
                            placeholder="{{ 'lblPackageName' | translate }}" maxlength="100" (keyup.enter)="onSearchPackage()">
                    </div>
                </div>
                <div class="col-auto" *ngIf="this.isDmsPlannerPackage">
                    <label translate>lblSource</label>
                    <div class="form-row">
                        <div class="col-auto mr-4" *ngIf="this.service.appointmentType === 'Order' && !this.service.isFromAdditionalWork">
                            <div class="p-0">
                                <input type="radio" id="idAll" [(ngModel)]="searchPackageListRequestModel.sourceId" name="sourceType" [value]="0" class="radio-custom"  />
                                <label class="form-check-label" for="idAll" translate>All</label>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="p-0">
                                <input type="radio" id="idPlanner" [(ngModel)]="searchPackageListRequestModel.sourceId" name="sourceType" [value]="1" class="radio-custom" />
                                <label class="form-check-label" for="idPlanner" translate>lblPlanner</label>
                            </div>
                        </div>
                        <div class="col-auto" *ngIf="this.service.appointmentType === 'Order' && !this.service.isFromAdditionalWork">
                            <div class="p-0">
                                <input type="radio" id="idDms" [(ngModel)]="searchPackageListRequestModel.sourceId" name="sourceType" [value]="4" class="radio-custom"  />
                                <label class="form-check-label" for="idDms" translate>DMS</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-auto" *ngIf="this.isDealerSpeficPackage">
                    <label translate>lblSource</label>
                    <div class="form-row">
                        <div class="col-auto mr-4">
                            <div class="p-0">
                                <input type="radio" id="idAll" [(ngModel)]="searchPackageListRequestModel.sourceId" name="sourceType" [value]="0" class="radio-custom"  />
                                <label class="form-check-label" for="idAll" translate>All</label>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="p-0">
                                <input type="radio" id="idPlanner" [(ngModel)]="searchPackageListRequestModel.sourceId" name="sourceType" [value]="1" class="radio-custom" />
                                <label class="form-check-label" for="idPlanner" translate>lblGeneral</label>
                            </div>
                        </div>
                        <div class="col-auto">
                            <div class="p-0">
                                <input type="radio" id="idDms" [(ngModel)]="searchPackageListRequestModel.sourceId" name="sourceType" [value]="4" class="radio-custom"  />
                                <label class="form-check-label" for="idDms" translate>lblMyPackage</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-auto">
                    <button class="btn btn-primary mt-22" type="button" (click)="onSearchPackage()">
                        <em class="fa fa-search"></em> Search
                    </button>
                </div>
            </div>
        </div>
        <div class="pad15">
            <div  class="card mb-0 scrollbar partlabor-scroll" [ngClass]="''">
                <div class="table-responsive max-h254"
                infinite-scroll
                [infiniteScrollDistance]="scrollDistance"
                [infiniteScrollThrottle]="throttle"
                [scrollWindow]="false"
                (scrolled)="onScrollDown($event)" >
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 20px" class="p-0" translate></th>
                                <th scope="col" style="width: 20px" class="p-0" translate></th>
                                <th scope="col" translate>lblPackageNumber</th>
                                <th scope="col" translate>lblPackageName</th>
                                <th scope="col" translate>lblMakeCode</th>
                                <th scope="col" class="text-right" translate>lblNoOfVersion</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="packageList?.length>0; else load_NotFound_Template">
                                <ng-container *ngFor="let package of packageList; let i=index">
                                    <tr (click)="getPackageVersion(package.id,i);package.expanded = !package.expanded" [ngClass]="{'bg-info': package.expanded}">
                                        <td>
                                            <div class="form-check p-0">
                                                <input type="radio"
                                                name="list"
                                                class="radio-custom"
                                                value="{{package.id}}"
                                                (click)="$event.stopPropagation()"
                                                (change)="onPackageChange(i)"
                                                [checked]="package.isPackageSelected" />
                                            </div>
                                        </td>
                                        <td class="p-0">
                                            <a class="btn" ngbTooltip=""
                                                tooltipClass="custom-revert">
                                                <em class="fas fa-chevron-right fa-lg text-success"
                                                    [ngClass]="{'fa-chevron-up': package.expanded}"></em>
                                            </a>
                                        </td>

                                        <td>
                                            <ngb-highlight [result]="package.packageNo">
                                            </ngb-highlight>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="package.name">
                                            </ngb-highlight>
                                        </td>
                                        <td>
                                            <ngb-highlight [result]="package.makeCode">
                                            </ngb-highlight>
                                        </td>
                                        <td  class="text-right">
                                            <ngb-highlight [result]="package.noOfVersion">
                                            </ngb-highlight>
                                        </td>
                                    </tr>
                                    <tr class="table-active" *ngIf="package.expanded">
                                        <td colspan="12" class="p-2 pl47">
                                            <table class="tablest1 border bg-virsion">
                                                <thead>
                                                    <tr>
                                                        <th scope="col" style="width: 20px" class="p-0" translate></th>
                                                        <th scope="col" style="width: 20px" class="p-0" translate></th>
                                                        <th scope="col" style="width: 23%" translate>lblVersionNumber</th>
                                                        <th scope="col" translate>lblVersionName</th>
                                                        <th scope="col" class="text-right" translate>lblNoOfItem</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <ng-container *ngIf="package.packageVersionList?.length>0; else load_NotFoundPartLocations_Template">
                                                        <ng-container *ngFor="let pac of package.packageVersionList; let j=index">
                                                            <tr (click)="getPackageBOM(package.id,pac.id,i,j);pac.expandedVersion = !pac.expandedVersion" >
                                                                <td>
                                                                    <div class="form-check p-0">
                                                                        <input type="radio"
                                                                        name="list-version"
                                                                        class="radio-custom"
                                                                        value="{{pac.id}}"
                                                                        (click)="$event.stopPropagation()"
                                                                        (change)="onPackageVersionChange(i,j)"
                                                                        [checked]="pac.isPackageVersionSelected" />
                                                                    </div>
                                                                </td>
                                                                <td  class="p-0">
                                                                    <a class="btn" ngbTooltip=""
                                                                        tooltipClass="custom-revert">
                                                                        <em class="fas fa-chevron-right fa-lg text-success"
                                                                            [ngClass]="{'fa-chevron-up': pac.expandedVersion}"></em>
                                                                    </a>
                                                                </td>
                                                                <td>
                                                                    <ngb-highlight [result]="pac.packageVersionNumber">
                                                                    </ngb-highlight>
                                                                </td>
                                                                <td>
                                                                    <ngb-highlight [result]="pac.name">
                                                                    </ngb-highlight>
                                                                </td>
                                                                <td  class="text-right">
                                                                    <ngb-highlight [result]="pac.noOfLine">
                                                                    </ngb-highlight>
                                                                </td>
                                                            </tr>
                                                            <tr  class="table-active" *ngIf="pac.expandedVersion">
                                                                <td colspan="12" class="p-2 pl47">
                                                                    <table  class="tablest1 border">
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope="col" translate>lblType</th>
                                                                                <th scope="col" translate>lblNumber</th>
                                                                                <th scope="col" translate>lblCostType</th>
                                                                                <th scope="col" translate>lblDescription</th>
                                                                                <th scope="col" style="width:100px"  class="text-right" translate>lblQty<span>/</span>
                                                                                    <span
                                                                                        translate>lblDuration</span>
                                                                                    (Hrs)</th>
                                                                                <th scope="col" style="width:100px"  class="text-right" translate>lblPrice</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <ng-container *ngIf="pac.packageBOMList?.length>0; else load_NotFoundPackageBOMList_Template">
                                                                                <ng-container *ngFor="let bom of pac.packageBOMList; let k=index">
                                                                                    <tr>
                                                                                        <td>
                                                                                            <ngb-highlight [result]="bom.typeName">
                                                                                            </ngb-highlight>
                                                                                        </td>
                                                                                        <td>
                                                                                            <ngb-highlight [result]="bom.no">
                                                                                            </ngb-highlight>
                                                                                        </td>
                                                                                        <td>
                                                                                            <ngb-highlight [result]="bom.costType">
                                                                                            </ngb-highlight>
                                                                                        </td>
                                                                                        <td>
                                                                                            <ngb-highlight [result]="bom.description">
                                                                                            </ngb-highlight>
                                                                                        </td>
                                                                                        <td class="text-right">{{bom.quantity| number:'1.2-2'}}</td>
                                                                                        <td class="text-right">{{bom.unitPrice| number:'1.2-2'}}</td>
                                                                                    </tr>
                                                                                </ng-container>
                                                                            </ng-container>
                                                                            <ng-template #load_NotFoundPackageBOMList_Template>
                                                                                <tr>
                                                                                    <td colspan="8" class="no-record" translate>
                                                                                        lblNoRecordsFound</td>
                                                                                </tr>
                                                                            </ng-template>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </ng-container>
                                                    </ng-container>
                                                    <ng-template #load_NotFoundPartLocations_Template>
                                                        <tr>
                                                            <td colspan="8" class="no-record" translate>
                                                                lblNoRecordsFound</td>
                                                        </tr>
                                                    </ng-template>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>

                            <ng-template #load_NotFound_Template>
                                <tr>
                                    <td colspan="8" class="no-record" translate>lblChangeSearchCriteria</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary btn-lg"  (click)="onSavePackage()"
    aria-label="Center Align" translate>lblAdd</button>
    <button type="button" class="btn btn-secondary btn-lg"
    (click)="OnClose()" aria-label="Center Align" translate>lblClose</button>
</div>
